export default __webpack_public_path__ + "static/media/whatsapp-icon-logo-s.1dc40b3d.svg";